export default __webpack_public_path__ + "static/media/yellow-camera.0df73e84.gif";